import { FilterDataPointString, Folder } from '@/api/generatedApi';

export interface FolderTreeNode {
  id: string;
  name: string;
  parentFolderId?: string;
  assetsCount: number;
  foldersCount: number;
  children: FolderTreeNode[];
}

export const buildFolderTree = (folders: Folder[], options?: { sort?: boolean }): FolderTreeNode[] => {
  const folderMap = new Map<string, FolderTreeNode>();
  const rootFolders: FolderTreeNode[] = [];

  for (const folder of folders) {
    const node: FolderTreeNode = {
      id: folder.id,
      name: folder.name,
      parentFolderId: folder.parentFolderId,
      assetsCount: folder.assetsCount,
      foldersCount: folder.foldersCount,
      children: [],
    };
    folderMap.set(folder.id, node);
  }

  for (const folder of folders) {
    const node = folderMap.get(folder.id)!;
    if (folder.parentFolderId) {
      const parent = folderMap.get(folder.parentFolderId);
      if (parent) {
        parent.children.push(node);
      }
    } else {
      rootFolders.push(node);
    }
  }

  if (options?.sort) {
    const sortChildren = (nodes: FolderTreeNode[]) => {
      nodes.sort((a, b) => a.name.localeCompare(b.name));
      for (const node of nodes) {
        sortChildren(node.children);
      }
    };
    sortChildren(rootFolders);
  }

  return rootFolders;
};

export const flattenFolderTree = (nodes: FolderTreeNode[]): FilterDataPointString[] => {
  const result: FilterDataPointString[] = [];

  const traverse = (node: FolderTreeNode, path: string = '') => {
    const currentPath = path ? `${path}/${node.name}` : node.name;
    result.push({
      filter: currentPath,
      count: node.assetsCount,
    });

    for (const child of node.children) {
      traverse(child, currentPath);
    }
  };

  for (const node of nodes) {
    traverse(node);
  }
  return result;
};
